module.exports = __webpack_public_path__ + "static/media/icon6.937f0f95.svg";